import React from 'react'
import {
  Card,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Checkbox,
  FormControlLabel,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material'
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDTypography from 'components/MDTypography'
import { createEmptyContact } from '../CustomerOnboardingWizard'

function ContactsStep({ contacts, setContacts, dropdowns, errors }) {
  const contactTypes = dropdowns.contactTypes || []
  const statusOptions = dropdowns.entityStatusOptions || []

  const updateContact = (id, field, value) => {
    setContacts((prev) =>
      prev.map((c) => (c.id === id ? { ...c, [field]: value } : c)),
    )
  }

  const addContact = () => {
    setContacts((prev) => [...prev, createEmptyContact()])
  }

  const removeContact = (id) => {
    setContacts((prev) => (prev.length > 1 ? prev.filter((c) => c.id !== id) : prev))
  }

  const segmentedStyle = {
    height: 44,
    borderRadius: 2,
    backgroundColor: "#f4f4f4",
    "& .MuiToggleButton-root": {
      textTransform: "none",
      fontWeight: 500,
      border: "none",
      borderRadius: 2,
      px: 2,
      "&.Mui-selected": {
        backgroundColor: "#49a3f1 !important",
        color: "#fff !important",
        transition: "all 0.2s ease",
      },
    },
  }

  return (
    <MDBox mt={2}>
      {contacts.map((c, idx) => {
        const contactErrors = errors?.[idx] || {}
        return (
          <Card key={c.id} variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <MDTypography variant="subtitle2" fontWeight="medium">
                  Contact #{idx + 1}
                </MDTypography>
                <MDButton
                  variant="text"
                  color="error"
                  size="small"
                  disabled={contacts.length === 1}
                  onClick={() => removeContact(c.id)}
                >
                  Remove
                </MDButton>
              </MDBox>

              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="First Name"
                    value={c.contact_first_name}
                    onChange={(e) => updateContact(c.id, 'contact_first_name', e.target.value)}
                    error={Boolean(contactErrors.contact_first_name)}
                    helperText={contactErrors.contact_first_name}
                    size="small"
                    InputProps={{
                      sx: { height: 40, minHeight: 40 }
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        height: 40,
                        minHeight: 40,
                        boxSizing: 'border-box',
                        display: "flex",
                        alignItems: "center",
                        padding: '16.5px 14px'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Last Name"
                    value={c.contact_last_name}
                    onChange={(e) => updateContact(c.id, 'contact_last_name', e.target.value)}
                    error={Boolean(contactErrors.contact_last_name)}
                    helperText={contactErrors.contact_last_name}
                    size="small"
                    InputProps={{
                      sx: { height: 40, minHeight: 40 }
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        height: 40,
                        minHeight: 40,
                        boxSizing: 'border-box',
                        display: "flex",
                        alignItems: "center",
                        padding: '16.5px 14px'
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    select
                    fullWidth
                    label="Contact Type"
                    value={c.contact_type_id}
                    onChange={(e) => updateContact(c.id, 'contact_type_id', e.target.value)}
                    error={Boolean(contactErrors.contact_type_id)}
                    helperText={contactErrors.contact_type_id}
                    size="small"
                    InputProps={{
                      sx: { height: 40, minHeight: 40 }
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        height: 40,
                        minHeight: 40,
                        boxSizing: 'border-box',
                        display: "flex",
                        alignItems: "center",
                        padding: '16.5px 14px'
                      }
                    }}
                  >
                    {contactTypes.map((type) => (
                      <MenuItem
                        key={type.contact_type_id}
                        value={type.contact_type_id}
                        sx={{
                          height: 40,
                          minHeight: 40,
                          display: "flex",
                          alignItems: "center"
                        }}
                      >
                        {type.type_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* <Grid item xs={12} md={3}>
                  <TextField
                    select
                    fullWidth
                    label="Status"
                    value={c.contact_status_type_id}
                    onChange={(e) =>
                      updateContact(c.id, 'contact_status_type_id', e.target.value)
                    }
                    size="small"
                    InputProps={{
                      sx: { height: 40, minHeight: 40 }
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        height: 40,
                        minHeight: 40,
                        boxSizing: 'border-box',
                        display: "flex",
                        alignItems: "center",
                        padding: '16.5px 14px'
                      }
                    }}
                  >
                    {statusOptions.map((s) => (
                      <MenuItem
                        key={s.status_option_id}
                        value={s.status_type_id}
                        sx={{
                          height: 40,
                          minHeight: 40,
                          display: "flex",
                          alignItems: "center"
                        }}
                      >
                        {s.StatusType.status_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}

                <Grid item xs={12} md={3}>
                  {/* <MDTypography variant="caption" fontWeight="bold" sx={{ mb: 1, display: "block" }}>
                    Status
                  </MDTypography> */}

                  <ToggleButtonGroup
                    fullWidth
                    exclusive
                    value={c.contact_status_type_id}
                    onChange={(e, value) =>
                      value &&  updateContact(c.id, 'contact_status_type_id',value)
                    }
                    sx={segmentedStyle}
                  >
                    {statusOptions.map((s) => {
                      const label = s.StatusType.status_name

                      return (
                        <ToggleButton
                          key={s.status_option_id}
                          value={s.status_type_id}
                          sx={{
                            textTransform: "none",
                            fontWeight: 500,
                          }}
                        >
                          {label}
                        </ToggleButton>
                      )
                    })}
                  </ToggleButtonGroup>

                  {errors?.status_type_id && (
                    <MDTypography variant="caption" color="error">
                      {errors.status_type_id}
                    </MDTypography>
                  )}
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Email"
                    value={c.email}
                    onChange={(e) => updateContact(c.id, 'email', e.target.value)}
                    error={Boolean(contactErrors.email)}
                    helperText={contactErrors.email}
                    size="small"
                    InputProps={{
                      sx: { height: 40, minHeight: 40 }
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        height: 40,
                        minHeight: 40,
                        boxSizing: 'border-box',
                        display: "flex",
                        alignItems: "center",
                        padding: '16.5px 14px'
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Phone"
                    value={c.phone}
                    onChange={(e) => updateContact(c.id, 'phone', e.target.value)}
                    size="small"
                    InputProps={{
                      sx: { height: 40, minHeight: 40 }
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        height: 40,
                        minHeight: 40,
                        boxSizing: 'border-box',
                        display: "flex",
                        alignItems: "center",
                        padding: '16.5px 14px'
                      }
                    }}
                  />
                </Grid>
                {/* <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Title"
                    value={c.title}
                    onChange={(e) => updateContact(c.id, 'title', e.target.value)}
                    size="small"
                    InputProps={{
                      sx: { height: 40, minHeight: 40 }
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        height: 40,
                        minHeight: 40,
                        boxSizing: 'border-box',
                        display: "flex",
                        alignItems: "center",
                        padding: '16.5px 14px'
                      }
                    }}
                  />
                </Grid> */}

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={Boolean(c.createUserAccount)}
                        onChange={(e) =>
                          updateContact(c.id, 'createUserAccount', e.target.checked)
                        }
                        color="primary"
                      />
                    }
                    label="Create user account for this contact"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )
      })}

      <MDButton variant="outlined" color="info" size="small" onClick={addContact}>
        Add Contact
      </MDButton>
    </MDBox>
  )
}

export default ContactsStep

